import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';
import { GET_SHOP, GET_SHOP_PUBLIC, SHOP_HAS_DELIVERY_FEE_ORDER } from 'redux/constants';

const apiStates = [
  ...restApiStates(['shop', 'items'], 'shopItem'),
  ...restApiStates(['shop'], 'shop', false, false, true),
  ...restApiStates(['shop', 'orders'], 'shopOrder'),
  // { type: GET_SHOP_PUBLIC, name: 'shopPublic' },
  // { type: GET_SHOP, name: 'shop' },
  { type: SHOP_HAS_DELIVERY_FEE_ORDER, name: 'deliveryFeeOrder' },
];

const instantStates = [];
const storage = {};
const listValues = ['sellersItems'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
